/**
 * Reseller-admin attribute-a-customer PICKER route — eager half (CLA-909).
 *
 * Registers the file route; the page component and all its atom / RPC / design
 * imports are deferred to `attribute.lazy.tsx` so they load only with this
 * route, never in the always-loaded `main` chunk (CLA-645). The admin gate is
 * inherited from the `admin_/resellers` layout route — this route adds no
 * `beforeLoad` of its own.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/resellers/$customerId/customers/attribute")({});
